export const discount=[
    {"name": "10% and above", "value": 10},
    {"name": "20% and above", "value": 20},
    {"name": "30% and above", "value": 30},
    {"name": "40% and above", "value": 40},
    {"name": "50% and above", "value": 50},
    {"name": "60% and above", "value": 60},
    {"name": "70% and above", "value": 70},
    {"name": "80% and above", "value": 80}
  ]
  